<template>
	<MStateBox :loading="report_detail.loading" :empty="isEmpty">
		<div class="report-detail">
			<template v-if="detail">
				<div class="report-detail--title">
					{{ detail.title }}
				</div>
				<div class="report-detail--time">
					<span class="institute-author">{{ detail.institutionName }} <i>|</i> {{ detail.author }}</span
					>{{ detail.time }}
				</div>
				<div class="report-detail--content" v-html="detail.conclusion"></div>
			</template>
		</div>
	</MStateBox>
</template>
<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import MStateBox from '@rebuild/components/MStateBox.vue';
import dayjs from 'dayjs';

const route = useRoute();
const { report_detail } = useModuleData();

// 统一的数据计算属性，避免重复取值
const detailData = computed(() => report_detail.data?.data || null);

// 处理后的详情数据
const detail = computed(() => {
	if (!detailData.value) return null;

	return {
		...detailData.value,
		time: dayjs(detailData.value.publishDate).format('YYYY-MM-DD')
	};
});

// 空状态判断
const isEmpty = computed(() => {
	return report_detail.empty || !detailData.value;
});

const loadDetail = async () => {
	const { id, type } = route.query;
	if (!id || !type) return;
	await report_detail.refresh({
		reportId: id,
		reportType: +type
	});
};

onMounted(() => {
	loadDetail();
});
</script>
<style lang="less" scoped>
.report-detail {
	min-height: 500px;
	&--title {
		color: rgb(34, 34, 34);
		font-size: 24px;
		font-weight: 600;
		line-height: 40px;
		letter-spacing: 0px;
		text-align: left;
	}
	&--time {
		height: 18px;
		display: flex;
		align-items: center;
		margin-top: 18px;
		font-size: 14px;
		font-weight: 400;
		color: #4e5969;
		.institute-author {
			margin-right: 16px;
			i {
				color: #c9cdd4;
				margin: 0 6px;
			}
		}
	}
	&--content {
		margin-top: 56px;
		line-height: 22px;
		font-size: 14px;
		color: #333;
		text-align: justify;
	}
}
</style>
